export const OrderStatus = {
  PAID: "PAID",
  NOT_PAID: "NOT_PAID",
  ERROR: "ERROR",
};